import { useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const VisitorTracker = () => {
  useEffect(() => {
    const sendVisitorNotification = async () => {
      try {
        // Get visitor info
        const visitorInfo = {
          timestamp: new Date().toISOString(),
          userAgent: navigator.userAgent,
          referrer: document.referrer || 'Direct',
          page: window.location.href,
          screenResolution: `${window.screen.width}x${window.screen.height}`,
        };

        // Send to backend
        await axios.post(`${BACKEND_URL}/api/visitor-notification`, visitorInfo);
        console.log('Visitor notification sent');
      } catch (error) {
        console.error('Error sending visitor notification:', error);
      }
    };

    // Send notification after a short delay to ensure page is loaded
    const timer = setTimeout(() => {
      sendVisitorNotification();
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return null; // This component doesn't render anything
};

export default VisitorTracker;
